import loadGif from '../../assets/icons/load.gif';
import styles from './DataLoadingGif.module.css';

/**
 * Animated loading GIF for in-page data fetches.
 * @param {{ size?: 'sm' | 'md' | 'lg' | 'xl', label?: string | null, className?: string, center?: boolean }} props
 * - sm: compact rows, cards, toolbars
 * - md: panels, forms waiting on data
 * - lg: large sections, half-page blocks
 * - xl: near full-page or primary content area
 */
function DataLoadingGif({ size = 'md', label = 'Loading…', className = '', center = true }) {
    const wrapClass = [styles.wrap, styles[size], center ? styles.center : '', className].filter(Boolean).join(' ');

    return (
        <div className={wrapClass} role="status" aria-live="polite" aria-busy="true">
            <img
                className={styles.gif}
                src={loadGif}
                alt=""
                decoding="async"
                draggable={false}
            />
            {label ? <span className={styles.label}>{label}</span> : null}
        </div>
    );
}

export default DataLoadingGif;
